module.exports = __webpack_public_path__ + "static/media/crunchbase.897757f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pictures/crunchbase.png
// module id = 156
// module chunks = 0